var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.tooltipTitle !== ""
        ? _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value: _vm.modalId,
                  expression: "modalId",
                },
                { name: "b-tooltip", rawName: "v-b-tooltip" },
              ],
              class: [
                { "btn-icon": _vm.buttonIcon },
                _vm.buttonWidthClass,
                _vm.buttonClass,
              ],
              attrs: {
                size: _vm.buttonSize,
                variant: _vm.buttonVariant,
                title: _vm.tooltipTitle,
              },
            },
            [
              _c("span", [_vm._t("default")], 2),
              _vm._v(" "),
              _vm.buttonIcon
                ? _c("svg-icon", {
                    class: "text-" + _vm.buttonIconVariant,
                    attrs: { icon: _vm.buttonIcon },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm.renderViaSlot
        ? _c(
            "button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value: _vm.modalId,
                  expression: "modalId",
                },
              ],
              class: _vm.buttonClass,
            },
            [_vm._t("default")],
            2
          )
        : _c(
            "b-button",
            {
              directives: [
                {
                  name: "b-modal",
                  rawName: "v-b-modal",
                  value: _vm.modalId,
                  expression: "modalId",
                },
              ],
              class: [
                { "btn-icon": _vm.buttonIcon },
                _vm.buttonWidthClass,
                _vm.buttonClass,
              ],
              attrs: { size: _vm.buttonSize, variant: _vm.buttonVariant },
            },
            [
              _c("span", [_vm._t("default")], 2),
              _vm._v(" "),
              _vm.buttonIcon
                ? _c("svg-icon", {
                    class: "text-" + _vm.buttonIconVariant,
                    attrs: { icon: _vm.buttonIcon },
                  })
                : _vm._e(),
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalId,
            title: _vm.title,
            "ok-title": _vm.confirmButtonTitle
              ? _vm.confirmButtonTitle
              : _vm.title,
            "ok-variant": _vm.confirmButtonVariant,
            "header-border-variant": _vm.variant,
            "ok-disabled": !_vm.isValid,
            "cancel-title": _vm.cancelButtonTitle,
            "cancel-variant": _vm.cancelButtonVariant,
            "header-close-label": "Abbrechen",
            "aria-live": "assertive",
            centered: "",
          },
          on: { ok: _vm.confirmed, cancel: _vm.cancelled, show: _vm.showing },
        },
        [
          _vm._t("description", function () {
            return [_c("p", [_vm._v(_vm._s(_vm.description))])]
          }),
          _vm._v(" "),
          _vm._t("text-area"),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }